var map = {
	"./help.svg": "M3Yb",
	"./icon-download.svg": "UFYl",
	"./icon-lock.svg": "rEo1",
	"./icon-login-out.svg": "qnMu",
	"./icon-login-pass.svg": "+icK",
	"./icon-login-user.svg": "6stH",
	"./icon-mini.svg": "dnbP",
	"./icon-msg.svg": "7bpU",
	"./icon-phoneAddress.svg": "8chv",
	"./icon-public.svg": "uRLr",
	"./icon-store.svg": "xzul",
	"./icon-user.svg": "D/EC",
	"./icon-vega.svg": "tM6k",
	"./icon-waybill.svg": "xyLY",
	"./order-status-1.svg": "Zzyc",
	"./order-status-2.svg": "Qpg+",
	"./order-status-3.svg": "sLXx",
	"./order-status-4.svg": "8a+U",
	"./orderlist-com.svg": "XwC+",
	"./orderlist-order.svg": "yY5T",
	"./orderlist-pos.svg": "hV3r",
	"./orderlist-price.svg": "UEc/",
	"./orderlist-store.svg": "Rj7L",
	"./orderlist-tel.svg": "5HMK",
	"./orderlist-time.svg": "UTZn",
	"./orderlist-user.svg": "HsZn",
	"./orderlist-veg.svg": "1xrQ",
	"./orderlist-way.svg": "qqmI",
	"./orderlist-waybill.svg": "FSqr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TNPD";


//////////////////
// WEBPACK FOOTER
// ./src/svg ./node_modules/xml-loader ^\.\/.*\.svg$
// module id = TNPD
// module chunks = 110